import React, { useMemo } from "react";
import { Calendar as CalendarIcon, CheckCircle2 } from "lucide-react";

// Compact 14-day availability strip showing available days vs busy slots
export default function AvailabilityCalendar({ availableDays = [], busySlots = [] }) {
  const days = useMemo(() => {
    const out = [];
    const today = new Date();
    for (let i = 0; i < 14; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() + i);
      out.push(d);
    }
    return out;
  }, []);

  const dayKey = (d) => ["sun","mon","tue","wed","thu","fri","sat"][d.getDay()];
  const isAvailable = (d) => availableDays.includes(dayKey(d));
  const dateStr = (d) => d.toISOString().slice(0, 10);
  const busyByDate = useMemo(() => {
    const m = {};
    (busySlots || []).forEach(s => {
      if (!s.scheduled_at) return;
      const k = new Date(s.scheduled_at).toISOString().slice(0, 10);
      m[k] = (m[k] || 0) + 1;
    });
    return m;
  }, [busySlots]);

  return (
    <div className="border border-border bg-card p-5" data-testid="availability-calendar">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">
          <CalendarIcon className="w-4 h-4 text-primary" /> Next 14 days
        </div>
        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          <span className="flex items-center gap-1.5"><span className="inline-block w-2.5 h-2.5 bg-primary" /> Available</span>
          <span className="flex items-center gap-1.5"><span className="inline-block w-2.5 h-2.5 bg-muted border border-border" /> Off</span>
          <span className="flex items-center gap-1.5"><span className="inline-block w-2.5 h-2.5 border border-primary" /> Booked</span>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-1">
        {days.map((d) => {
          const avail = isAvailable(d);
          const busy = busyByDate[dateStr(d)] > 0;
          return (
            <div key={dateStr(d)} className={`aspect-square flex flex-col items-center justify-center text-xs border ${
              !avail ? "bg-muted/40 border-border text-muted-foreground" :
              busy ? "border-primary bg-card text-foreground" :
              "bg-primary/10 border-primary/40 text-foreground"
            }`} data-testid={`day-${dateStr(d)}`}>
              <div className="uppercase tracking-widest text-[10px]">{dayKey(d)}</div>
              <div className="font-display text-base font-medium">{d.getDate()}</div>
              {avail && !busy && <CheckCircle2 className="w-3 h-3 text-primary mt-0.5" />}
              {busy && <div className="text-[10px] text-primary">{busyByDate[dateStr(d)]} bk</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
